import axios from "../api/axios";
import config from '../config/config';
import {IntentEnum} from "../enums/IntentEnum";
import {MessageTypeEnum} from "../enums/MessageTypeEnum";

function SendData(intent, data) {
    var promise = new Promise(function (resolve, reject) {
        axios
            .post(config.endPoint + "/api/millai/prompt",
                JSON.stringify({Intent: intent, data: data}), {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true,
                })
            .then((response) => {
                //ked isStopping tak vyskladat vlastny obj response.data
                /* response =
                    {
                    "Intent": "PromtEmbeddings",
                    "Data": {
                        "DocsEnvId": 0,
                        "Messages": [
                            {
                                "MessageID": "bdb74d32-f8af-406d-b12b-adbb77a5533a",
                                "Role": "assistant",
                                "Type": 3,
                                "Table": null,
                                "Language": "slk",
                                "SystemMessage": "",
                                "UserDocsMessage": [],
                                "Message": "Kúpna zmluva musí obsahovať dohodnutú kúpnu cenu alebo musí obsahovať aspoň určený spôsob jej dodatočného určenia. Taktiež musí obsahovať záväzok predávajúceho dodať kupujúcemu hnuteľnú vec (tovar) určenú jednotlivo alebo čo do množstva a druhu a previesť na neho vlastnícke právo k tejto veci, a záväzok kupujúceho zaplatiť kúpnu cenu. Okrem toho musí byť v zmluve ustanovený spôsob dodania tovaru a odovzdania dokladov, ktoré sú potrebné na prevzatie a na užívanie tovaru, ako aj ďalšie doklady ustanovené v zmluve. "
                            }
                        ]
                    },
                    "Status": "OK"
                  }
                */
                let obj = JSON.parse(response.data);
                resolve(obj);
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
    return promise;
}

export function getFavouriteQuestions(intent) {
    return new Promise((resolve, reject) => {
        SendData(
            'GetUserQuestions',
            {
                Intent: intent /*TAB na ktorom sa nachadzame*/,
                Language: 'en',
            }
        )
            .then((data) => {
                resolve(data.Data);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    });
}

export function findSimilar(sourceText) {
    return new Promise((resolve, reject) => {
        SendData(
            'FindSimilar',
            {
                SourceText: sourceText,
            }
        )
        .then((data) => {
            resolve(data.Data);
        })
        .catch((err) => {
            console.log(err);
            reject(err);
        });
    });

}

export function compareNorms(sourceText, chapter) {
    return new Promise((resolve, reject) => {
        SendData(
            'CompareNorms',
            {
                SourceText: sourceText,
                ComparedText: chapter?.Chunk ?? ''
            }
        )
            .then((data) => {
                resolve(data.Data);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    });

}

export function saveFavouriteQuestion(intent, question, docsEnvId) {
    if (intent !== 'PromtData') {
        return new Promise((resolve, reject) => {
            SendData('SetUserQuestions', {
                Intent: intent,
                Question: question,
                Language: 'en',
                DocsEnvId: docsEnvId
            })
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                });
        });
    } else {
        return new Promise((resolve, reject) => {
            SendData('SetUserQuestions', {
                Intent: intent,
                Question: question,
                Language: 'en'
            })
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                });
        });
    }
}

export function deleteFavouriteQuestion(id) {
    return new Promise((resolve, reject) => {
        SendData('RemoveUserQuestions', {Id: id})
            .then((data) => {
                resolve(true);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    });
}

export function saveQuestionRating(msg, rating) {
    var promise = new Promise(function (resolve, reject) {
        axios
            .post(config.endPoint + "/api/millai/prompt",
                JSON.stringify({
                    Intent: "SaveQuestionRating",
                    data: {
                        "MessageID": msg,
                        "Rating": rating
                    }
                }), {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true,
                })
            .then((response) => {
                let obj = JSON.parse(response.data);
                resolve(obj);
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
    return promise;
}

export function sendMessageToBE(selectedIntent, messageHistory, formData, id, sourceText, comparedText) {
    return new Promise((resolve, reject) => {
        const data = {};
        const message = messageHistory[0];
        switch (selectedIntent) {
            case IntentEnum.SendQuestion: {
                const firstMessage = message.chat[0];
                const last6Messages = message.chat.slice(message.chat.length > 6 ? -6 : -(message.chat.length - 1));

                const messages = [firstMessage, ...last6Messages];
                data.Messages = messages;
                data.SourceText = sourceText;
                data.ComparedText = comparedText
                break;
            }

            case IntentEnum.FreeQuestion: {
                selectedIntent = IntentEnum.SendQuestion;
                const messages = message.chat.slice(-6);
                data.Messages = messages;
                data.SourceText = sourceText;
                data.ComparedText = comparedText
                break;
            }
        }

        SendData(
            selectedIntent,
            data,
        )
            .then((data) => {
                if (!!data.Data.Message) {
                    resolve({
                        Role: 'assistant',
                        Type: MessageTypeEnum.Text,
                        Message: data.Data.Message,
                    });
                } else if (data.data.Messages && data.Data.Messages.length > 0 && data.Data.Messages[0].Type === 0) {
                    resolve({
                        Role: 'assistant',
                        Type: data.Data.Messages[0].Type,
                        Message: data.Data.Messages[0].Message,
                    });
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function getComparePrompt() {
    return new Promise((resolve, reject) => {
        SendData('GetComparePrompt', {})
            .then((data) => {
                resolve(data.Data);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    });
}

export function setComparePrompt(prompt) {
    return new Promise((resolve, reject) => {
        SendData('SetComparePrompt', {Prompt: prompt})
            .then((data) => {
                resolve(data.Data);
            })
            .catch((err) => {
                console.log(err);
                reject(err);
            });
    });
}
